import { isValid, format, addDays, isDate } from "date-fns";
import { DateRange } from "@mui/x-date-pickers-pro";

/**
 * Generates an array of dates in string format for a given date range
 * @param {array} dateRange - Array containing start and end dates
 * @returns {string[]} Array of dates in 'YYYY-MM-DD' format
 * @throws {Error} If invalid date range is provided
 */
export default (dateRange: DateRange<Date>) => {
  if (!Array.isArray(dateRange) || dateRange.length !== 2) {
    throw new Error("Input must be an array with exactly 2 elements.");
  }

  const [startDate, endDate] = dateRange;

  if (!isDate(startDate) || !isValid(startDate)) {
    throw new Error("Start date must be a valid Date object.");
  }

  // If endDate is null, return only startDate
  if (endDate === null) {
    return [format(startDate, "yyyy-MM-dd")];
  }

  if (!isDate(endDate) || !isValid(endDate)) {
    throw new Error("End date must be a valid Date object or null");
  }

  if (startDate > endDate) {
    throw new Error("Start date must be before or equal to end date");
  }

  const dates = [];
  let currentDate = startDate;

  while (currentDate <= endDate) {
    dates.push(format(currentDate, "yyyy-MM-dd"));
    currentDate = addDays(currentDate, 1);
  }

  return dates;
};
